import * as yup from 'yup';

import { FrequencyType } from './constants';

const MIN_CURRENCY_VALUE = 5;

export const validationSchema = yup.object().shape({
  recurring_frequency_type: yup.string().required('Informe o tipo de frequência de cobrança'),
  recurring_frequency: yup.number().when('recurring_frequency_type', {
    is: FrequencyType.PERSONALIZADO,
    then: yup.number().min(1).required('Informe o tempo da frequência de cobrança'),
  }),
  overdue_limit: yup.number().when('remove_access', {
    is: true,
    then: yup.number().min(1).required('Informe a quantia máxima de parcelas atrasadas'),
  }),
  limit_charges: yup.number().when('undetermined_charges', {
    is: 'false',
    then: yup.number().min(2).required('Informe a quantia de cobranças para o contrato se encerrar'),
  }),
  trial_days: yup.number().when('trial', {
    is: true,
    then: yup.number().min(1).required('Informe a quantia máxima de DIAS do período de avaliação'),
  }),
  plan_title: yup.string().required('Nome do plano é obrigatório').min(6).max(100),
  plan_description: yup.string().required('Descrição do plano é obrigatória').min(100).max(4000),
  prices: yup.array().when('membership_fee', (fee, schema) => {
    if (fee) {
      return schema.of(
        yup.object().shape({
          value: yup.number().required().min(MIN_CURRENCY_VALUE, 'O valor deve ser no mínimo 5'),
          membership_value: yup.number().required().min(MIN_CURRENCY_VALUE, 'O valor deve ser no mínimo 5'),
          currency_code: yup.string().required(),
        })
      );
    }

    return schema.of(
      yup.object().shape({
        value: yup.number().required().min(MIN_CURRENCY_VALUE, 'O valor deve ser no mínimo 5'),
        membership_value: yup.number(),
        currency_code: yup.string().required(),
      })
    );
  }),
});
